"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileUpload = void 0;
var FileDropProps_1 = require("./FileDropProps");
var FileUpload = function (uuid, file, url, onUpdate) {
    var reader = new FileReader();
    var xhr = new XMLHttpRequest();
    xhr.upload.addEventListener("progress", function (e) {
        if (e.lengthComputable) {
            var percentage = Math.round((e.loaded * 100) / e.total);
            onUpdate(uuid, FileDropProps_1.FileUploadStatus.Pending, percentage);
        }
    }, false);
    xhr.upload.addEventListener("load", function (_) {
        onUpdate(uuid, FileDropProps_1.FileUploadStatus.Available, 100);
    }, false);
    xhr.open("PUT", url);
    reader.onload = function (_) { return xhr.send(reader.result); };
    try {
        reader.readAsArrayBuffer(file);
    }
    catch (e) {
        console.error(e);
    }
    return {
        cancel: function () {
            xhr.abort();
            onUpdate(uuid, FileDropProps_1.FileUploadStatus.Deleted, 0);
        },
    };
};
exports.FileUpload = FileUpload;
